import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M24 12a1 1 0 0 0-1-1h-3.91a.51.51 0 0 1-.49-.4 6.8 6.8 0 0 0-.94-2.28.5.5 0 0 1 .06-.63l2.77-2.76a1 1 0 1 0-1.42-1.42l-2.76 2.77a.5.5 0 0 1-.63.06 6.8 6.8 0 0 0-2.28-.94.5.5 0 0 1-.4-.49V1a1 1 0 0 0-2 0v3.91a.51.51 0 0 1-.4.49 6.8 6.8 0 0 0-2.28.94.5.5 0 0 1-.63-.06L4.93 3.51a1 1 0 0 0-1.42 1.42l2.77 2.76a.5.5 0 0 1 .06.63 6.8 6.8 0 0 0-.94 2.28.5.5 0 0 1-.49.4H1a1 1 0 0 0 0 2h3.91a.51.51 0 0 1 .49.4 6.8 6.8 0 0 0 .94 2.28.5.5 0 0 1-.06.63l-2.77 2.76a1 1 0 1 0 1.42 1.42l2.76-2.77a.5.5 0 0 1 .63-.06 6.8 6.8 0 0 0 2.28.94.5.5 0 0 1 .4.49V23a1 1 0 0 0 2 0v-3.91a.51.51 0 0 1 .4-.49 6.8 6.8 0 0 0 2.28-.94.5.5 0 0 1 .63.06l2.76 2.77a1 1 0 1 0 1.42-1.42l-2.77-2.76a.5.5 0 0 1-.06-.63 6.8 6.8 0 0 0 .94-2.28.5.5 0 0 1 .49-.4H23a1 1 0 0 0 1-1m-8.74 2.5A5.76 5.76 0 0 1 9.5 8.74a5.7 5.7 0 0 1 .16-1.31.49.49 0 0 1 .34-.36 5.4 5.4 0 0 1 1.8-.31 5.47 5.47 0 0 1 5.46 5.46 5.4 5.4 0 0 1-.31 1.8.49.49 0 0 1-.35.32 5.5 5.5 0 0 1-1.34.16"
    }, null, -1)
  ]));
}
const LightDarkModeToggle = { render };
export {
  LightDarkModeToggle as default,
  render
};
//# sourceMappingURL=LightDarkModeToggle.svg.js.map
